import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { editorialLocales } from '@/routing/editorial';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import type { Locale } from '@/helpers/locale-helper';
type EditorialLocale = {
	country: string;
	webLocale: string;
	flag: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'GuideLanding',
  setup(__props) {

const { locales, webLocale } = useLanguageStore();

const filteredLocales = computed(() =>
	locales.value.filter((locale: Locale) => editorialLocales.includes(locale.webLocale))
);

const editorialLocalesList = computed(() => {
	let localesArr: EditorialLocale[] = [];

	filteredLocales.value.map((locale: Locale) => {
		localesArr.push({
			country: locale.iso_3166_2,
			webLocale: locale.webLocale,
			flag: `${JW_CONFIG.ASSETS_URL}/flags/${locale.webLocale.toUpperCase()}.png`,
		});
	});

	return localesArr;
});

const currentLocale = computed(() => {
	return (
		editorialLocalesList.value.find(locale => locale.webLocale === webLocale.value) ??
		editorialLocalesList.value.find(locale => locale.webLocale === 'us')
	);
});

const displayedLocaleList = computed(() => {
	return editorialLocalesList.value.filter(locale => locale.webLocale !== currentLocale.value?.webLocale);
});

function getGuideHomeUrl(targetLocale: string) {
	const path = `/${targetLocale}`;
	const { protocol, host } = window.location;
	return `${protocol}//${host}${path}`;
}

return { __sfc: true,locales, webLocale, filteredLocales, editorialLocalesList, currentLocale, displayedLocaleList, getGuideHomeUrl, faChevronRight }
}

})